<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import FaInfo from 'svelte-icons/fa/FaInfoCircle.svelte';
import FaTimesCircle from 'svelte-icons/fa/FaTimesCircle.svelte';

let showInfo = false;
export let infoText = '';
export let legend = '';
export let yOffest = '-120px';
</script>

<div class="font-light text-base pt-0" style="display: flex;">
    {#if legend != ""}
        <legend aria-describedby="textLengthHint">{legend}</legend>
    {/if}
    <button
        class="icon tooltip"
        aria-hidden="true"
        on:click={() => (showInfo = !showInfo)}
        >{#if showInfo === false}
            <FaInfo />
        {:else}
            <FaTimesCircle />
        {/if}
    </button>
    <span
        class="tooltiptext tooltip-top"
        class:showHint={showInfo}
        id="textLengthHint"
        style="transform: translate(-280px, {yOffest});"
    >
        {infoText}
    </span>
</div>

<style>
    .icon.tooltip:hover {
        color: #9b9b9b;
    }

    .tooltip-top {
        text-align: left !important;

        width: 300px;
    }
</style>
